module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.images) ? _c('div', {
    class: _vm.classes
  }, [(_vm.variant === 'topic' || _vm.variant === 'topic - reverse') ? [(_vm.mobile && _vm.mobileImage.src) ? _c('collection-image', {
    class: ['collection-spread-mobile-img', {
      'collection-spread-mobile-img--bleed': _vm.mobileImageBleed
    }],
    attrs: {
      "image": _vm.mobileImage
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    ref: "stickyheader",
    class: ['collection-spread--column', 'collection-topic-text', {
      'sticky-header': _vm.images.length > 1
    }]
  }, [_c('div', {
    staticClass: "collection-spread--row"
  }, [_c('h2', {
    staticClass: "h2 uppercase"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('div', {
    staticClass: "h6 textbody justify-center",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])]), _vm._v(" "), (!_vm.mobile) ? _c('section', {
    staticClass: "collection-spread--column"
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "collection-spread--row"
    }, [_c('collection-image', {
      attrs: {
        "image": _vm.buildImgObj(image)
      }
    })], 1)
  }), 0) : _vm._e()] : _vm._l((_vm.images), function(image, index) {
    return (index < 2) ? _c('section', {
      staticClass: "collection-spread--column"
    }, [_c('div', {
      staticClass: "collection-spread--row"
    }, [_c('collection-image', {
      attrs: {
        "image": _vm.buildImgObj(image)
      }
    })], 1)]) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0882d86e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collection__Story__Spread.vue
// module id = 372
// module chunks = 1